<template>
  <el-dialog
    title="复制文本窗口(Copy text window)"
    width="80%"
    center
    :visible.sync="visible"
    @close="close">
    <div>
      <el-input
        id="copy"
        type="textarea"
        autosize
        v-model="text">
      </el-input>
    </div>
    <div slot="footer">
      <button class="copy-btn" :data-clipboard-text="text">复制到剪切板(Copy to clipboard)</button>
      <button class="copy-btn" @click="download">保存到本地文件(Save to local file！)</button>
    </div>
  </el-dialog>
</template>

<script>
import Clipboard from 'clipboard';

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
      text: '',
    };
  },
  watch: {
    dialogVisible(val) {
      this.visible = val;
    },
    dialogData(val) {
      this.text = val;
    },
  },
  created() {
    let clipboard = new Clipboard('.copy-btn');
    clipboard.on('success', () => {
      this.$message.success('复制成功(Copy succeeded)');
    });
    clipboard.on('error', () => {
      this.$message.success('复制失败(copy failed)');
    });
  },
  methods: {
    close() {
      this.$emit('close');
    },
    download() {
      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.text));
      element.setAttribute('download', 'Data_download_link.txt');   
      element.style.display = 'none';
      document.body.appendChild(element);   
      element.click();   
      document.body.removeChild(element);
    },
  }
}
</script>

<style scoped>
.copy-btn {
  color: #fff;
  background: #0058a3;
  border: none;
  font-size: 12px;
  border-radius: 3px;
  display: inline-block;
  line-height: 1;
  cursor: pointer;
  font-weight: 500;
  padding: 7px 15px;
  outline: none;
  box-shadow: none;
  margin: 0 4px;
}
</style>